// Generated by scripts/build-ui-icons.mjs.
export { Book as default } from "../ui/glyphs-1";
